module.exports = __webpack_public_path__ + "img/APCSPCPT.fd09dede.png";